import { createContext, useContext, useState } from 'react';

const HostAchievementDetailContext = createContext();

const initialState = {};

const initialFilterState = {
  yearMonth: new Date(new Date().setDate(1)),
  brand: null,
  metric: { label: 'AOV', value: 'aov' },
};

const HostAchievementDetailProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(initialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const updateFilterState = (payload) => setFilterState((prev) => ({ ...prev, ...payload }));
  const resetState = () => setState(initialState);
  const resetFilterState = () => setFilterState(initialFilterState);

  return (
    <HostAchievementDetailContext.Provider value={{ updateState, updateFilterState, resetState, resetFilterState, state, filterState }}>
      {children}
    </HostAchievementDetailContext.Provider>
  );
};

export const useHostAchievementDetailState = () => {
  return useContext(HostAchievementDetailContext);
};

export default HostAchievementDetailProvider;
